// AIchat/src/components/GoogleLoginButton.js
import React, { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';

const GoogleLoginButton = () => {
  const { googleLogin } = useAuth();

  useEffect(() => {
    const initGoogleAuth = () => {
      if (window.google && window.google.accounts) {
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: async (response) => {
            const credential = response.credential;
            // Decode JWT to get email, name, etc.
            const parts = credential.split('.');
            const payload = JSON.parse(atob(parts[1]));
            const googlePayload = {
              credential: credential,
              email: payload.email,
              name: payload.name,
              picture: payload.picture,
              given_name: payload.given_name,
              family_name: payload.family_name,
            };
            try {
              await googleLogin(googlePayload);
            } catch (error) {
              console.error('Login to server failed:', error);
            }
          },
        });
        window.google.accounts.id.renderButton(
          document.getElementById('google-login-btn'),
          { theme: 'outline', size: 'large' }
        );
      } else {
        // Retry if not loaded
        setTimeout(initGoogleAuth, 100);
      }
    };

    initGoogleAuth();
  }, [googleLogin]);

  return (
    <div>
      <div id="google-login-btn"></div>
    </div>
  );
};

export default GoogleLoginButton;